import { Box, Button, Stack, styled, Typography } from '@mui/material';

import LandingBG from '@/assets/background/landing-bg.png';

export const CheckoutButton = styled(Button)(({ theme: { palette } }) => ({
  position: 'absolute',
  top: 100,
  right: 0,
  padding: '25px 20px',
  fontSize: 25,
  gap: 5,
  height: 65,
  zIndex: 10,
  borderTopLeftRadius: 30,
  borderBottomLeftRadius: 30,
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  color: palette.horizonWhite.main,
  backgroundColor: '#1AB394',
  '&:hover': {
    backgroundColor: '#1AB394',
  },
}));

export const SummaryBox = styled(Box)(({ theme: { palette } }) => ({
  backgroundColor: palette.horizonWhite.main,
  border: '1px solid #E5E3E3',
  color: palette.horizonText.main,
}));

export const SummaryBoxTitle = styled(Stack)(({ theme: { palette } }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontWeight: 600,
  fontSize: 18,
  backgroundColor: '#F3F3F3',
  padding: '14px 15px',
  color: palette.horizonText.main,
  borderBottom: '1px solid #E5E3E3',
}));

export const CardTitleType = styled(Box)(() => ({
  textTransform: 'uppercase',
  display: 'flex',
  justifyContent: 'space-between',
}));

export const CardTitle = styled(Typography)(({ theme: { palette } }) => ({
  fontSize: 18,
  fontWeight: 'bold',
  color: palette.primary.main,
}));

export const CardDescription = styled(Typography)(({ theme: { palette } }) => ({
  fontSize: 18,
  fontWeight: 'bold',
  color: palette.horizonGray2.main + '70',
}));

export const CardBody = styled(Stack)(() => ({
  padding: 20,
  backgroundColor: '#F3F3F3',
  border: '1px solid #E5E3E3',
}));

export const CardPrice = styled(Typography)(({ theme: { palette } }) => ({
  fontSize: 40,
  fontWeight: 'bold',
  color: palette.primary.main,
}));

export const CardGst = styled(Typography)(({ theme: { palette } }) => ({
  fontSize: 20,
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'flex-end',
  paddingBottom: 8,
  paddingLeft: 4,
  color: palette.primary.main,
}));

export const ButtonContainer = styled(Box)(({ theme: { palette } }) => ({
  fontWeight: 600,
  margin: '0px -20px',
  fontSize: 20,
  padding: 20,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: palette.horizonBlue1.main,
  color: palette.horizonWhite.main,
}));

export const BodyContainer = styled(Box)(() => ({
  margin: '20px 0px',
}));

export const CardUsers = styled(Typography)(({ theme: { palette } }) => ({
  fontWeight: 600,
  fontSize: 14,
  margin: '-10px 0 20px 0',
  color: palette.horizonText.main,
}));

export const ScrollableContainer = styled(Stack)(() => ({
  overflow: 'scroll',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  '&-ms-overflow-style:': {
    display: 'none',
  },
}));

export const MainContainer = styled(Stack)(() => ({
  width: '100%',
  height: 'auto',
  minHeight: '100vh',
  backgroundImage: `url(${LandingBG})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right bottom',
  backgroundAttachment: 'fixed',
  backgroundSize: '30%',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '20px 0',
  overflow: 'auto',
}));
